module.exports = __webpack_public_path__ + "img/sceneIcon3-3.9add72fd.png";